"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableLanguages = void 0;
exports.availableLanguages = [
    {
        id: 'en-GB',
        label: 'common.english',
        subLabel: 'common.en-gb',
        value: 'en-GB',
    },
    {
        id: 'en-US',
        label: 'common.english',
        subLabel: 'common.en-us',
        value: 'en-US',
    },
    {
        id: 'de',
        label: 'common.german',
        subLabel: 'common.de-de',
        value: 'de',
    },
    {
        id: 'de-CH',
        label: 'common.german',
        subLabel: 'common.de-ch',
        value: 'de-CH',
    },
    {
        id: 'da',
        label: 'common.german',
        subLabel: 'common.de-at',
        value: 'da',
    },
    {
        id: 'fr-CH',
        label: 'common.french',
        subLabel: 'common.fr-ch',
        value: 'fr-CH',
    },
    {
        id: 'it-CH',
        label: 'common.italian',
        subLabel: 'common.it-ch',
        value: 'it-CH',
    },
];
//# sourceMappingURL=available-languages.js.map